export const blockIconsImageStraighten = (
	<span className='material-symbols-outlined'>straighten</span>
);
